import { BlobServiceClient } from "@azure/storage-blob";
const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
const sasToken = process.env.REACT_APP_STORAGESASTOKEN;
const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
const blobService = new BlobServiceClient(
  `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
);
const containerClient = blobService.getContainerClient(containerName);
export const isStorageConfigured = () => {
  return !storageAccountName || !sasToken ? false : true;
};
export const getBlobsInContainer = async () => {
  const returnedBlobUrls = [];

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat()) {
    // if image is public, just construct URL
    console.log("blob", blob);
    returnedBlobUrls.push({
      blobName: blob.name,
      blobUrl: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`,
    });
  }

  return returnedBlobUrls;
};

export const createBlobInContainer = async (file) => {
  console.log("createBlobInContainer file", file);
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(file.name);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadData(file, options);
};
export const deleteBlobIfItExists = async (blobName) => {
  // include: Delete the base blob and all of its snapshots.
  // only: Delete only the blob's snapshots and not the blob itself.
  const options = {
    deleteSnapshots: "include", // or 'only'
  };

  // Create blob client from container client
  const blockBlobClient = await containerClient.getBlockBlobClient(blobName);

  await blockBlobClient.deleteIfExists(options);

  console.log(`deleted blob ${blobName}`);
};
